import { render, staticRenderFns } from "./CarouselSlide.vue?vue&type=template&id=3c07119a&"
import script from "./CarouselSlide.vue?vue&type=script&lang=ts&"
export * from "./CarouselSlide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CarouselSlide.vue"
export default component.exports